import React from "react";
import { Controller, useForm } from "react-hook-form";
import { DropdownList } from "react-widgets";
import { toastr } from "react-redux-toastr";
import ErrorMessage from "../../../../components/text/ErrorMessage";
import { CreateLead, Lead } from "../../../../core/api/models";
import api from "../../../../api";
import { useLead, useHasPermission, AppPermissions } from "../../../../core";
import { useMasterData } from "../../../../core/hooks/useMasterData";
import RemoteDataDropDown from "../../../../components/dropdown/RemoteDataDropDown";

const LeadEdit: React.FunctionComponent<{
  error?: string;
  leadDetails?: Lead;
  onUpdate?: () => void;
  fields: { displayName: string; value: string; type: string; group: string }[];
}> = (props) => {
  const { updateLead, updating, leadError, updateShowroom } = useLead(api.lead);
  const masterData = useMasterData(api.settings);
  const [leadIntent, setLeadIntent] = React.useState<string>(
    props?.leadDetails?.leadIntent?._id || ""
  );
  const [type, setType] = React.useState<string>(
    props.leadDetails?.leadType?._id || ""
  );

  const canUpdateLeadSettings =
    useHasPermission(AppPermissions.UpdateLeadSettings) &&
    props?.leadDetails?.isEditable;

  const loadShowroom = async () => {
    const response = await api.settings.getShowrooms({
      ecommerceOnly: true,
    });
    return response;
  };

  const { control, handleSubmit, errors } = useForm<CreateLead>({
    reValidateMode: "onChange",
    mode: "onSubmit",
  });

  const onSubmit = async (leadData?: any) => {
    const updateData = {
      leadType: type || props.leadDetails?.leadType?._id,
      businessSource:
        leadData?.businessSource || props.leadDetails?.businessSource?._id,
      leadIntent: leadIntent || props.leadDetails?.leadIntent?._id,
      initialTouchPoint:
        leadData?.initialTouchPoint ||
        props.leadDetails?.initialTouchPoint?._id,
      title: "",
    };
    try {
      updateLead(updateData, props?.leadDetails?._id, () => {
        if (leadData.showroomId) {
          updateShowroom(props?.leadDetails?._id, leadData.showroomId, () => {
            toastr.success("Success", "Lead updated successfully");
            props.onUpdate?.();
          });
        } else {
          toastr.success("Success", "Lead updated successfully");
          props.onUpdate?.();
        }
      });
    } catch (error) {
      if (error?.response?.data?.data?.message) {
        toastr.error("Error", error?.response?.data?.data?.message.join());
      } else {
        toastr.error("Error", error?.response?.data?.message);
      }
    }
  };

  const leadIntentSelect = (vaue: string) => {
    setLeadIntent(vaue);
    setType("");
  };

  const leadTypeSelect = (vaue: string) => {
    setType(vaue);
  };

  const leadType = masterData?.data?.leadTypes.filter(
    (x) => x.leadIntent?._id === leadIntent?.toString()
  );

  return (
    <div className="p-4 accordion__body border-bottom">
      <form onSubmit={handleSubmit(onSubmit)}>
        {!!props?.fields?.filter((x) => x.value === "leadIntent")?.length &&
          !props.leadDetails?.leadIntent && (
            <div className="form-group font-weight-semibold mb-3">
              <label htmlFor="" className="font-sm text-uppercase">
                Lead Intent
              </label>
              <Controller
                control={control}
                name="leadIntent"
                defaultValue={props.leadDetails?.leadIntent?._id}
                render={({ onChange, value }) => (
                  <DropdownList
                    value={value}
                    defaultValue={value}
                    data={masterData?.data?.leadIntents}
                    textField={"name"}
                    valueField={"_id"}
                    placeholder={"Select Lead Intent"}
                    onChange={(val) => leadIntentSelect(val._id)}
                    autoFocus={true}
                    disabled={!canUpdateLeadSettings}
                  />
                )}
              />
              {errors.leadIntent && (
                <ErrorMessage>Lead Intent is required</ErrorMessage>
              )}
            </div>
          )}
        {!!props?.fields?.filter((x) => x.value === "leadType")?.length &&
          !props.leadDetails?.leadType && (
            <div className="form-group font-weight-semibold mb-3">
              <label htmlFor="" className="font-sm text-uppercase">
                Lead Type
              </label>
              <Controller
                control={control}
                name="leadType"
                defaultValue={props.leadDetails?.leadType?._id}
                render={({ onChange, value }) => (
                  <DropdownList
                    value={type}
                    defaultValue={type}
                    data={leadType}
                    textField={"name"}
                    valueField={"_id"}
                    placeholder={"Select Lead Type"}
                    onChange={(val) => leadTypeSelect(val._id)}
                    disabled={!canUpdateLeadSettings}
                  />
                )}
              />
              {errors.leadType && (
                <ErrorMessage>Lead Type is required</ErrorMessage>
              )}
            </div>
          )}
        {/* {!!props?.fields?.filter((x) => x.value === "initialTouchPoint")
          ?.length &&
          !props.leadDetails?.initialTouchPoint && (
            <div className="form-group font-weight-semibold mb-3">
              <label htmlFor="" className="font-sm text-uppercase">
                Initial Touch Point
              </label>
              <Controller
                control={control}
                name="initialTouchPoint"
                defaultValue={props.leadDetails?.initialTouchPoint?._id}
                render={({ onChange, value }) => (
                  <DropdownList
                    value={value}
                    defaultValue={value}
                    data={masterData?.data?.initialTouchPoints}
                    textField={"name"}
                    valueField={"_id"}
                    placeholder={"Select Initial Touch Point"}
                    onChange={(val) => {
                      onChange(val._id);
                    }}
                    disabled={!canUpdateLeadSettings}
                  />
                )}
              />
              {errors.initialTouchPoint && (
                <ErrorMessage>Initial Touch Point is required</ErrorMessage>
              )}
            </div>
          )} */}
        {/* {!!props?.fields?.filter((x) => x.value === "businessSource")?.length &&
          !props.leadDetails?.businessSource && (
            <div className="form-group font-weight-semibold mb-3">
              <label htmlFor="" className="font-sm text-uppercase">
                Source of business
              </label>
              <Controller
                control={control}
                name="businessSource"
                defaultValue={props.leadDetails?.businessSource?._id}
                render={({ onChange, value }) => (
                  <DropdownList
                    value={value}
                    defaultValue={value}
                    data={masterData?.data?.businessSources?.filter(
                      (x) => x.parentId
                    )}
                    textField={"name"}
                    valueField={"_id"}
                    placeholder={"Select Source of business"}
                    onChange={(val) => {
                      onChange(val._id);
                    }}
                    disabled={!canUpdateLeadSettings}
                  />
                )}
              />
              {errors.businessSource && (
                <ErrorMessage>Source of business is required</ErrorMessage>
              )}
            </div>
          )} */}
        {!!props?.fields?.filter((x) => x.value === "showroomId")?.length &&
          !props.leadDetails?.showroomId && (
            <div className="form-group font-weight-semibold mb-3">
              <label htmlFor="" className="font-sm text-uppercase">
              Office{" "}
              </label>
              <Controller
                control={control}
                name="showroomId"
                defaultValue={props.leadDetails?.showroom}
                render={({ onChange, value, name }) => (
                  <RemoteDataDropDown
                    loadData={loadShowroom}
                    textField="title"
                    value={value}
                    defaultValue={value}
                    valueField="_id"
                    onChange={(val) => {
                      onChange(val._id);
                    }}
                    placeholder="Select Office"
                  ></RemoteDataDropDown>
                )}
              />
            </div>
          )}
        <div className="mb-2 mt-2">
          {leadError && <span className="message_validation">{leadError}</span>}
        </div>
        <div className="form-group font-weight-semibold mb-3 text-right pt-3">
          <button
            className="btn btn-primary font-weight-semibold font-normal px-4 "
            disabled={updating}
          >
            Submit
          </button>
        </div>
      </form>
    </div>
  );
};

export default LeadEdit;
